module.exports = __webpack_public_path__ + "static/media/Andriana Gutierrez.99e3bc4a.png";